var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.828 11.227h-5.127v-1.055c0-.647-.524-1.172-1.172-1.172H16.471c-.648 0-1.172.525-1.172 1.172v1.055h-5.127c-.647 0-1.172.524-1.172 1.171v3.106c0 3.77 2.818 6.894 6.459 7.376a8.68 8.68 0 0 0 4.91 6.247 4.03 4.03 0 0 1-3.928 3.076h-.644a1.17 1.17 0 0 0-1.133.874l-1.172 4.453A1.172 1.172 0 0 0 14.625 39h18.75c.768 0 1.329-.727 1.133-1.47l-1.172-4.453a1.17 1.17 0 0 0-1.133-.874h-.644a4.03 4.03 0 0 1-3.928-3.076 8.68 8.68 0 0 0 4.91-6.247c3.64-.482 6.459-3.606 6.459-7.376v-3.106c0-.647-.525-1.171-1.172-1.171m-22.53 9.246a5.11 5.11 0 0 1-3.954-4.97V13.57h3.955zM31.3 34.547l.555 2.11h-15.71l.555-2.11zm-.943-13.33a6.34 6.34 0 0 1-4.374 6.042 1.17 1.17 0 0 0-.805 1.16 6.35 6.35 0 0 0 1.436 3.784h-5.228a6.35 6.35 0 0 0 1.437-3.784 1.17 1.17 0 0 0-.806-1.16 6.34 6.34 0 0 1-4.374-6.042v-9.873h12.714zm6.3-5.713a5.11 5.11 0 0 1-3.956 4.969V13.57h3.955z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLeaderboard);
export default __webpack_public_path__ + "static/media/IcoLeaderboard.39e7eafb546bf1ace7c6a73bd0afa205.svg";
export { ForwardRef as ReactComponent };